export enum SubmitFieldType {
  Dropdown = 'dropdown',
  CheckBox = 'checkbox',
  RadioButton = 'radio-button',
  TextBox = 'textbox',
  TOS = 'terms-of-service',
  ReadyForDigitalSignature = 'ready-for-digital-signature',
  ReadyForDigitalSignatureRadioButton = 'ready-for-digital-signature-radio-button',
  DealerList = 'dealer-list',
}
